/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { FormsModule } from '@angular/forms';
import { HttpModule }    from '@angular/http';
import { PlcComponent } from './plc/plc.component';
import { InaxPlcService } from '../../plc/src/plc';
import { PlcInput } from './plcInput';
import { InaxSignalR } from '../../common/src/signalR/inaxSignalR';
import { ClipboardDirective } from './directives/clipboard/clipboard.directive';
import { PlcTextboxComponent } from './plcTextbox/plc-textbox.component';
import { PlcButtonComponent } from './plcButton/plc-button.component';
import { PlcCheckboxComponent } from './plcCheckbox/plc-checkbox.component';
import { PlcRadioComponent } from './plcRadio/plc-radio.component';
import { PlcStateComponent } from './plcState/plc-state.component';




@NgModule({
    imports:
    [
        //Modules
        BrowserModule,
        FormsModule,
        HttpModule
    ],
    exports:
    [
        PlcComponent,
        PlcTextboxComponent,
        PlcButtonComponent,
        PlcCheckboxComponent,
        PlcRadioComponent,
        PlcStateComponent
    ],
    declarations:
    [
        //Components
        PlcComponent,
        PlcTextboxComponent,
        PlcButtonComponent,
        PlcCheckboxComponent,
        PlcRadioComponent,
        PlcStateComponent,
        ClipboardDirective
    ],
    providers:
    [
        InaxPlcService,
        InaxSignalR
    ],
    bootstrap: []
})

export class PlcUiModule {
    constructor() {}
 }